const routeTypeConst = {
  0: 'top',
  1: 'organisation',
  2: 'group',
  3: 'user'
}

export default {
  methods: {
    routeType() {
      const { organisationId, userId, groupId } = this.$route.params
      const length = [organisationId, userId, groupId].filter(Boolean).length
      return routeTypeConst[length]
    }
  }
}
